import { render, staticRenderFns } from "./ReportOrdersLabModal.vue?vue&type=template&id=60d64627&"
import script from "./ReportOrdersLabModal.vue?vue&type=script&lang=js&"
export * from "./ReportOrdersLabModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports